import { handleActions } from "redux-actions";
import { setAuthRequiredPermissions } from "../actions/actions";

export default handleActions(
  {
    [setAuthRequiredPermissions]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
